import React, { memo } from "react";
import PropTypes from "prop-types";

const NotFound = memo(({ children, ...props }) => {
	return (
		<div className="col-xs-12" {...props}>
			<span className={`glyphicon glyphicon-exclamation-sign red-icon padding-right-5px`} aria-hidden="true" />
			<span>{children || `-`}</span>
		</div>
	);
});
NotFound.displayName = `NotFound`;
NotFound.propTypes = {
	children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default NotFound;
